import {
  Autocomplete,
  Button,
  Input,
  NumberInput,
  Select,
} from "@mantine/core";
import {
  IconBuildingWarehouse,
  IconClipboardList,
  IconFileText,
  IconMapPin,
  IconPackage,
  IconStack,
  IconTruck,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";

import { orpcClient } from "@/lib/orpc-client";
import { single, allOrThrow } from "@/lib/orpc-batch";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function EditStockRequestDoneListPage() {
  const { t } = useTranslation();
  const [stockRequestDoneData, setStockRequestDoneData] = useState<any>({
    company: localStorage.getItem("companyId"),
    name: "",
    remarks: "",
    deliveryPerson: "",
    warehouseStaffId: null,
  });
  const [editStockRequestDoneData, setEditStockRequestDoneData] = useState<any>(
    {}
  );
  const [tempProductList, setTempProductList] = useState<any[]>([]);
  const [tempProductData, setTempProductData] = useState<any[]>([]);
  const [tempProductInput, setTempProductInput] = useState<any[]>([]);
  const [tempWarehouseData, setTempWarehouseData] = useState<any[]>([]);
  const [tempWarehouseInput, setTempWarehouseInput] = useState<any[]>([]);
  const [tempStorageLocationInput, setTempStorageLocationInput] = useState<
    any[]
  >([]);
  const [tempAmount, setTempAmount] = useState<any[]>([]);
  const [employeeData, setEmployeeData] = useState<any[]>([]);
  const [warehouseStaffInput, setWarehouseStaffInput] = useState("");
  const [disable, setDisable] = useState<any[]>([]);
  const [warehouseMap, setWarehouseMap] = useState<any>({});

  const [deleteProductList, setDeleteProductList] = useState<any[]>([]);

  const { id } = useParams();

  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const navigate = useNavigate();

  const parseId = (value: string) =>
    typeof value === "string"
      ? value.match(/ID:\s*([a-zA-Z0-9-]+)/)?.[1] ?? null
      : null;

  const handleSubmit = async (
    editStockRequestDoneData: any,
    tempProductList: any[],
    deleteProductList: any[]
  ) => {
    try {
      if (Object.keys(editStockRequestDoneData)?.length) {
        const { name, remarks, deliveryPerson, warehouseStaffId } =
          editStockRequestDoneData;
        const dataToUpdate = {
          id: id!,
          ...(name !== undefined && { name }),
          ...(remarks !== undefined && { remarks }),
          ...(deliveryPerson !== undefined && { deliveryPerson }),
          ...(warehouseStaffId !== undefined && { warehouseStaffId }),
        };
        await single(orpcClient.stockRequest.update([dataToUpdate]));
      }

      if (deleteProductList?.length) {
        await allOrThrow(
          orpcClient.stockRequestProduct.delete(
            deleteProductList.map((productId) => ({ id: productId }))
          )
        );
      }

      let editTempProductList: any[] = [];

      let newTempProductList: any[] = [];

      tempProductList?.map((t) => {
        if (t?.id) {
          editTempProductList.push(t);
        } else {
          newTempProductList.push(t);
        }
      });

      if (editTempProductList?.length) {
        await allOrThrow(
          orpcClient.stockRequestProduct.update(
            editTempProductList.map((data) => ({
              id: data?.id,
              stockRequestId: id!,
              amount: data?.amount,
            }))
          )
        );
      }

      if (newTempProductList?.length) {
        await allOrThrow(
          orpcClient.stockRequestProduct.create(
            newTempProductList.map((data) => ({
              amount: data?.amount,
              productId: data?.product?.id,
              stockRequestId: id!,
              storageLocationId: data?.storageLocation,
            }))
          )
        );
      }
    } catch (error) {
      console.error("api error", error);
      return;
    }
    navigate(`/hrMainPage/stockRequestDone/${id}`);
  };

  const handleDataChange = (name: string, value: any) => {
    setStockRequestDoneData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setEditStockRequestDoneData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeWarehouseStaff = (value: string, employeeData: any[]) => {
    setWarehouseStaffInput(value);
    const idNumber = parseId(value);
    const selectedData = employeeData.find((e: any) => e?.id == idNumber);
    handleDataChange("warehouseStaffId", selectedData?.id ?? null);
  };

  const handleDeleteProductList = (index: number, id?: string) => {
    const updatedProductList = [...tempProductList];

    updatedProductList.splice(index, 1);

    setTempProductInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempWarehouseInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempStorageLocationInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempAmount((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setDisable((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempProductList(updatedProductList);

    //新增的不用call delete API
    if (id) {
      setDeleteProductList((prev) => [...prev, id]);
    }
  };

  const handleOnOptionSubmit = (
    type: string,
    e: string,
    data: any[],
    index: number
  ) => {
    let selectedData: any;
    if (type === "product") {
      selectedData = data.filter((item: any) => item?.name === e)[0];
      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = { ...updatedList[index], [type]: selectedData };
        return updatedList;
      });
    } else {
      let idBehindMatch = e.match(/ID:\s*([a-zA-Z0-9-]+)/);
      let documentID = idBehindMatch ? idBehindMatch[1].trim() : null;

      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = {
          ...updatedList[index],
          storageLocation: documentID,
        };
        return updatedList;
      });
    }
  };

  const handleAddProductList = (productList: any[]) => {
    const updatedProductList = [...productList, []];

    setTempProductList(updatedProductList);
    setDisable((prev) => {
      return [...prev, false];
    });
  };

  const handleDisplaySelectMembers = (data: any[]) => {
    return data?.map((t) => ({ value: t?.id, label: t?.name }));
  };
  const handleDisplaySelectWarehouse = (data: any[]) => {
    return data?.map((t) => {
      return `倉庫： ${t?.name},  ID: ${t?.id}`;
    });
  };

  const handleDisplaySelectStorageLocation = (
    warehouseInput: string,
    warehouseData: any[]
  ) => {
    if (!warehouseInput) return;

    let match = warehouseInput?.match(/ID:\s*([a-zA-Z0-9-]+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = warehouseData.filter((e: any) => e?.id == idNumber)[0];

    if (selectedData?.storageLocation) {
      return selectedData?.storageLocation.map(
        (location: any) => `儲位： ${location?.name}    , ID: ${location?.id}`
      );
    } else {
      return;
    }
  };

  const { name, remarks, deliveryPerson } = stockRequestDoneData || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await single(orpcClient.stockRequest.read([{ id: id! }]));

        setStockRequestDoneData(result);

        const productList = result?.stockRequestProduct || [];

        const warehouses = await orpcClient.warehouse.list({});
        const warehouseDataMap: any = {};
        await Promise.all(
          (warehouses ?? []).map(async (warehouse) => {
            const areas = await orpcClient.warehouseArea.list({
              filter: { warehouseId: warehouse?.id },
            });
            (areas ?? []).forEach((area) => {
              if (area?.id) warehouseDataMap[area.id] = warehouse;
            });
          })
        );
        setWarehouseMap(warehouseDataMap);

        setTempProductList(
          productList.map((item) => {
            const {
              id,
              amount,
              stockRequestId,
              productId,
              storageLocationId,
            } = item;

            return {
              id,
              amount,
              stockRequestId,
              productId,
              storageLocationId,
            };
          })
        );

        setTempProductInput(productList?.map((item) => item?.product?.id));
        setTempWarehouseInput(
          productList?.map((item) => {
            const warehouseAreaId = item?.storageLocation?.warehouseAreaId;
            const warehouse = warehouseDataMap[warehouseAreaId];
            return warehouse
              ? `倉庫： ${warehouse?.name},  ID: ${warehouse?.id}`
              : "";
          })
        );
        setTempStorageLocationInput(
          productList?.map((item) => {
            return `儲位： ${item?.storageLocation?.name}    , ID: ${item?.storageLocation?.id}`;
          })
        );

        setTempAmount(productList?.map((item) => item?.amount));

        setDisable(productList?.map(() => true));
      } catch (error) {
        console.error("Error fetching stock request data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await orpcClient.product.list({});

        setTempProductData(result);
      } catch (error) {
        console.error("Error fetching products data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await orpcClient.warehouse.list({});

        const warehousesWithLocations = await Promise.all(
          (result ?? []).map(async (warehouse: any) => {
            const areas = await orpcClient.warehouseArea.list({
              warehouseId: warehouse?.id,
            });
            const storageLocation = (areas ?? []).flatMap(
              (area: any) => area?.storageLocation ?? []
            );
            return { ...warehouse, storageLocation };
          })
        );

        setTempWarehouseData(warehousesWithLocations);
      } catch (error) {
        console.error("Error fetching warehouses data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await orpcClient.employee.list({});
        setEmployeeData(result || []);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const staffId = stockRequestDoneData?.warehouseStaffId;
    if (staffId && employeeData?.length) {
      const emp = employeeData.find((e: any) => e?.id === staffId);
      if (emp) setWarehouseStaffInput(`${emp.name} (ID: ${emp.id})`);
    }
  }, [stockRequestDoneData?.warehouseStaffId, employeeData]);

  const fieldWrapper = (
    label: React.ReactNode,
    Icon: React.ComponentType<{ size?: number | string }> | undefined,
    children: React.ReactNode
  ) => (
    <div className="space-y-1.5">
      <label className="flex items-center gap-1.5 text-xs text-gray-500">
        {Icon ? <Icon size={13} /> : null}
        {label}
      </label>
      {children}
    </div>
  );

  return (
    <div className="min-h-screen p-8">
      <div className="mx-auto max-w-3xl rounded-xl bg-white p-8 space-y-5">
        <div>
          <div className="text-4xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("stockRequest.editStockRequest") || "編輯領料單"}
          </div>
          <div className="mt-2 text-sm text-gray-500">
            {name || t("stockRequest.stockRequestManagement") || "領料單管理"}
          </div>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-6 py-4">
            <IconFileText size={16} className="text-blue-600" />
            <h3 className="text-sm font-medium text-gray-700">
              {t("stockRequest.basicInfo") || "基本資訊"}
            </h3>
          </div>
          <div className="p-6">
            {fieldWrapper(
              t("stockRequest.stockRequestName") || "領料單名稱",
              IconClipboardList,
              <Input
                value={name}
                onChange={({ target: { value } }) =>
                  handleDataChange("name", value)
                }
                leftSection={<IconClipboardList size={16} />}
              />
            )}
          </div>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-6 py-4">
            <IconPackage size={16} className="text-blue-600" />
            <h3 className="text-sm font-medium text-gray-700">
              {t("stockRequest.productList") || "商品清單"}
            </h3>
          </div>
          <div className="space-y-4 p-6">
            {tempProductList.map((item, i) => {
              return (
                <div
                  className="rounded-lg border border-gray-200 p-4"
                  key={item?.id ?? i}
                >
                  <div className="mb-3 flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">
                      #{i + 1}
                    </span>
                    <button
                      type="button"
                      onClick={() => handleDeleteProductList(i, item?.id)}
                      className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-white text-red-500 hover:bg-red-50"
                    >
                      <IconX size={16} />
                    </button>
                  </div>
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {fieldWrapper(
                      t("stockRequest.productName") || "商品名稱",
                      IconPackage,
                      <Select
                        searchable
                        nothingFoundMessage="查無資料"
                        disabled={disable[i]}
                        leftSection={<IconPackage size={16} />}
                        data={handleDisplaySelectMembers(tempProductData)}
                        value={tempProductInput[i] || null}
                        onChange={(value) => {
                          setTempProductInput((prev) => {
                            const updated = [...prev];
                            updated[i] = value;
                            return updated;
                          });
                          const selectedData = tempProductData.find(
                            (p: any) => p?.id === value
                          );
                          setTempProductList((prev: any[]) => {
                            const updated = [...prev];
                            updated[i] = {
                              ...updated[i],
                              product: selectedData,
                            };
                            return updated;
                          });
                        }}
                      />
                    )}

                    {fieldWrapper(
                      t("stockRequest.warehouseLabel") || "倉庫",
                      IconBuildingWarehouse,
                      <Autocomplete
                        disabled={disable[i]}
                        leftSection={<IconBuildingWarehouse size={16} />}
                        data={handleDisplaySelectWarehouse(tempWarehouseData)}
                        value={tempWarehouseInput[i] || ""}
                        onChange={(value) => {
                          setTempWarehouseInput((prev) => {
                            const updated = [...prev];
                            updated[i] = value;
                            return updated;
                          });

                          setTempStorageLocationInput((prev) => {
                            const updated = [...prev];
                            updated[i] = [];
                            return updated;
                          });
                        }}
                      />
                    )}

                    {fieldWrapper(
                      t("stockRequest.storageLocationLabel") || "儲位",
                      IconMapPin,
                      <Autocomplete
                        disabled={disable[i]}
                        leftSection={<IconMapPin size={16} />}
                        data={handleDisplaySelectStorageLocation(
                          tempWarehouseInput[i],
                          tempWarehouseData
                        )}
                        value={tempStorageLocationInput[i] || ""}
                        onChange={(value) =>
                          setTempStorageLocationInput((prev) => {
                            const updated = [...prev];
                            updated[i] = value;
                            return updated;
                          })
                        }
                        onOptionSubmit={(e) => {
                          handleOnOptionSubmit(
                            "warehouse",
                            e,
                            tempWarehouseData,
                            i
                          );
                        }}
                      />
                    )}

                    {fieldWrapper(
                      t("stockRequest.quantity") || "數量",
                      IconStack,
                      <NumberInput
                        leftSection={<IconStack size={16} />}
                        value={tempAmount[i] || ""}
                        onChange={(e) => {
                          setTempProductList((prev) => {
                            const updatedList = [...prev];
                            updatedList[i] = { ...updatedList[i], amount: e };
                            return updatedList;
                          });

                          setTempAmount((prev) => {
                            const updated = [...prev];
                            updated[i] = e;
                            return updated;
                          });
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}

            <Button
              variant="default"
              fullWidth
              radius="md"
              onClick={() => handleAddProductList(tempProductList)}
            >
              {t("stockRequest.addProductRow") || "增加商品列"}
            </Button>
          </div>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-6 py-4">
            <IconTruck size={16} className="text-blue-600" />
            <h3 className="text-sm font-medium text-gray-700">
              {t("stockRequest.deliveryInfo") || "交貨資訊"}
            </h3>
          </div>
          <div className="space-y-4 p-6">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {fieldWrapper(
                t("stockRequest.requestPerson") || "領料人員",
                IconUser,
                <Input
                  leftSection={<IconUser size={16} />}
                  value={deliveryPerson}
                  onChange={(e) =>
                    handleDataChange("deliveryPerson", e.target.value)
                  }
                />
              )}
              {fieldWrapper(
                t("stockRequest.outboundStaff") || "出庫人員",
                IconTruck,
                <Autocomplete
                  leftSection={<IconTruck size={16} />}
                  value={warehouseStaffInput}
                  data={employeeData?.map(
                    (emp) => emp?.name + ` (ID: ${emp?.id})`
                  )}
                  onChange={(e) => handleChangeWarehouseStaff(e, employeeData)}
                />
              )}
            </div>
            {fieldWrapper(
              t("stockRequest.remarks") || "備註",
              IconFileText,
              <Input
                leftSection={<IconFileText size={16} />}
                value={remarks}
                onChange={(e) => handleDataChange("remarks", e.target.value)}
              />
            )}
          </div>
        </div>

        <div className="flex gap-4">
          <Button
            variant="default"
            fullWidth
            radius="md"
            onClick={() => navigate(`/hrMainPage/stockRequestDone`)}
          >
            {t("stockRequest.cancel") || "取消"}
          </Button>

          <Button
            variant="filled"
            color="gray"
            fullWidth
            radius="md"
            onClick={() =>
              handleSubmit(
                editStockRequestDoneData,
                tempProductList,
                deleteProductList
              )
            }
          >
            {t("stockRequest.submitEdit") || "送出編輯"}
          </Button>
        </div>
      </div>
    </div>
  );
}
export default EditStockRequestDoneListPage;
